const toNumber = (value: unknown, fallback = 0) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

export function mapOrderToTransaction(order: any) {
  const orderLines = Array.isArray(order?.orderLines)
    ? order.orderLines
    : Array.isArray(order?.invoiceItemList)
      ? order.invoiceItemList
      : Array.isArray(order?.posOrderLines)
        ? order.posOrderLines
        : Array.isArray(order?.lines)
          ? order.lines
          : [];
  const saleDateValue =
    order?.saleDate ??
    order?.createdAt ??
    order?.createdDate ??
    order?.date ??
    null;
  const saleDate = saleDateValue ? new Date(saleDateValue) : new Date();
  const totalItems = orderLines.reduce(
    (sum: number, line: any) => sum + Math.max(1, toNumber(line?.quantity, 1)),
    0
  );
  const fallbackItemCount = toNumber(
    order?.items ??
    order?.itemCount ??
    order?.itemsCount ??
    order?.totalItems ??
    order?.totalItem ??
    order?.numberOfItems ??
    order?.lineCount,
    0
  );

  return {
    rawId: toNumber(order?.id ?? order?.orderId ?? order?.posOrderId, 0),
    id:
      order?.invoiceNumber ??
      order?.orderNumber ??
      order?.receiptNo ??
      `TXN-${toNumber(order?.id ?? order?.orderId ?? 0)}`,
    time: saleDate.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }),
    date: saleDate.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }).replace(/ /g, '-'),
    amount: `${toNumber(order?.grandTotal ?? order?.total ?? order?.netAmount, 0).toFixed(2)}`,
    items: totalItems || fallbackItemCount || orderLines.length,
    cashier:
      order?.counterSession?.user?.name ??
      order?.cashierName ??
      order?.createdByUserName ??
      'N/A',
    customer:
      order?.customer?.name ??
      order?.customerName ??
      order?.partyProfile?.name ??
      undefined,
    paymentMethod:
      (Array.isArray(order?.payments) && order.payments[0]?.methodName) ||
      order?.paymentMethodName ||
      'N/A',
    paymentMethods: Array.isArray(order?.payments) && order.payments.length > 0
      ? order.payments.map((p: any) => ({ method: p?.methodName ?? p?.paymentMethodName ?? 'Payment', amount: toNumber(p?.amount ?? p?.paidAmount, 0) }))
      : [{ method: order?.paymentMethodName ?? 'Payment', amount: toNumber(order?.grandTotal ?? order?.total ?? order?.netAmount, 0) }],
    subtotal: toNumber(order?.subTotal ?? order?.subtotal, 0),
    tax: toNumber(order?.totalTaxAmount ?? order?.taxAmount, 0),
    discount: toNumber(order?.totalDiscountAmount ?? order?.discountAmount, 0),
    total: toNumber(order?.grandTotal ?? order?.total ?? order?.netAmount, 0),
    itemsList: orderLines.map((line: any, index: number) => ({
      id: String(line?.id ?? line?.itemId ?? index + 1),
      name: line?.itemName ?? line?.name ?? line?.item?.name ?? 'Item',
      sku: line?.itemCode ?? line?.sku ?? line?.code ?? '-',
      quantity: toNumber(line?.quantity ?? line?.qty, 1),
      unitPrice: toNumber(line?.price ?? line?.unitPrice, 0),
      discount: toNumber(
        line?.discountItemAmount ?? line?.discountAmount ?? line?.totalItemDiscount,
        0,
      ),
      vat: toNumber(
        line?.taxAmount ??
          line?.vatAmount ??
          line?.totalTaxAmount ??
          (Array.isArray(line?.taxes)
            ? line.taxes.reduce(
                (sum: number, tax: any) =>
                  sum +
                  toNumber(
                    tax?.amount ??
                      tax?.taxAmount ??
                      tax?.value ??
                      tax?.tax?.amount,
                    0
                  ),
                0
              )
            : 0),
        0
      ),
      total: toNumber(line?.amount ?? line?.subTotal ?? line?.total, 0),
      isBogoFreeItem: !!(
        line?.promoId > 0 ||
        line?.itemTransactions?.[0]?.bogoItem ||
        line?.promoItem
      ),
    })),
  };
}
